import { render, staticRenderFns } from "./index.vue?vue&type=template&id=322d287e&"
import script from "./formatting.component.js?vue&type=script&lang=js&"
export * from "./formatting.component.js?vue&type=script&lang=js&"
import style0 from "./formatting.style.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports